import { useOrganizationData } from '@/features/organizations/organization.hooks';
import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useParams } from 'react-router';
import { useGuideline } from '../api/guidelines';
import { GuidelineForManipulation, GuidelineForm } from '../components/GuidelineForm';

export default function EditGuideline() {
  const { guidelineId } = useParams();

  const defaultValues = {
    type: undefined,
    name: undefined,
    file: undefined,
    filename: undefined,
    url: undefined,
    diseaseConditions: [
      {
        cancerTypeId: undefined,
        cancerPathologyId: undefined,
        cancerLocationId: undefined,
        sortOrder: 0,
      },
    ],
    assignAllOrganizations: false,
    organizations: [] as {
      label: string;
      value: string;
    }[],
  } as GuidelineForManipulation;
  const { data: guidelineToEdit } = useGuideline(guidelineId);
  const orgData = useOrganizationData();
  if (guidelineToEdit) {
    defaultValues.name = guidelineToEdit.name;
    defaultValues.type = guidelineToEdit.type;
    defaultValues.url = guidelineToEdit.url;
    defaultValues.filename = guidelineToEdit.filename;
    defaultValues.diseaseConditions = guidelineToEdit.diseaseConditions;
    defaultValues.assignAllOrganizations = guidelineToEdit.assignAllOrganizations;
    defaultValues.organizations = guidelineToEdit.organizationIds.map((orgId) => {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      const org = orgData.find((org) => org.value === orgId);
      return {
        label: org?.label || '',
        value: orgId,
      };
    });
  }

  return (
    <div className="h-2/3">
      <h1 className="ml-1 text-3xl font-semibold">Edit Guideline</h1>
      <div className="py-3">
        <GuidelineForm guidelineId={guidelineId} defaultValues={defaultValues} />
      </div>
    </div>
  );
}
